import { sortBy } from 'es-toolkit';
import { NominationRef } from '../../models';
import { getRoleRank } from './get-role-rank';

export const sortCountryNominationRefs = (nominationRefs: NominationRef[], isDescending: boolean): NominationRef[] => {
  const sorted = sortBy(nominationRefs, [(ref) => getRoleRank(ref.role)]);
  return isDescending ? sorted.reverse() : sorted;
}